/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeRosterSettingsCtrl
 */
angular.module('mercury.modules.time.roster')
  .controller('TimeRosterSettingsCtrl', ["dialog", "ngToast", "Rosters", "title", "userinfo", "$scope", "$window", function (dialog, ngToast, Rosters, title, userinfo, $scope, $window) {
    $scope.token = userinfo.companyPreferenceGet('time.rosterPublicToken');
    $scope.rosterShared = ($scope.token && $scope.token !== '0');

    // If this isn't used as a sub controller of the roster editor.
    if (!title.title) {
      title.set('Roster Settings');
    }

    $scope.getLink = function () {
      return $window.location.origin + '/App/PublicRoster#/roster/' + userinfo.activeCompany() + '/' + $scope.token;
    };

    function guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    $scope.changeShare = function (isPublic) {
      $scope.token = (isPublic) ? guid() : '0';
    };

    $scope.save = function () {
      if ($scope.token == userinfo.companyPreferenceGet('time.rosterPublicToken')) {
        return;
      }
      $scope.saving = Rosters.setPublicToken($scope.token);
      $scope.saving.then(function () {
        ngToast.success('Roster Settings have been saved.');
      });
    };
  }]);
